__turbopack_context__.v({
  "description": "hero-banner-module-scss-module__8YAiwG__description",
  "heroBanner": "hero-banner-module-scss-module__8YAiwG__heroBanner",
  "linkList": "hero-banner-module-scss-module__8YAiwG__linkList",
  "picture": "hero-banner-module-scss-module__8YAiwG__picture",
  "text": "hero-banner-module-scss-module__8YAiwG__text",
  "title": "hero-banner-module-scss-module__8YAiwG__title",
  "toolTip": "hero-banner-module-scss-module__8YAiwG__toolTip",
});
